import { render, staticRenderFns } from "./enforce-resolution.vue?vue&type=template&id=4a2bd96d&scoped=true"
import script from "./enforce-resolution.vue?vue&type=script&lang=js"
export * from "./enforce-resolution.vue?vue&type=script&lang=js"
import style0 from "./enforce-resolution.vue?vue&type=style&index=0&id=4a2bd96d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_nd5b4b5ys5eo7bulp7f5cn4bfu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a2bd96d",
  null
  
)

export default component.exports